module.exports = __webpack_public_path__ + "static/media/Star_Icon_Web@2x.43ada31e.png";